import { HttpClient, HttpParams, HttpHeaders, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { state } from '@angular/animations';
import {environment} from '../../environments/environment';

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  env = environment;
  url: string;
  getProgress: boolean = false;
  postProgress: boolean = false;

  constructor(public http: HttpClient, public router: Router) {
    this.url = this.env.apiUrl;
  }

  getApiStatus() {
    if (this.getProgress || this.postProgress) {
      return true;
    } else {
      return false;
    }
  }

  get(endpoint: string, isMemberAuth?: any) {
    this.getProgress = true;
    return this.http.get(this.url + '/' + endpoint, this.getHttpHeaders(isMemberAuth)).pipe(
      map(res => {
       
        
        this.getProgress = false;
        return res;
      }),
      catchError(err => {
        this.getProgress = false;
        return 'failed';
      })
    );
  }
  
  
  post(endpoint: string, body: any, isMemberAuth?: any) {
    this.postProgress = true;
    return this.http.post(this.url + '/' + endpoint, body, this.getHttpHeaders(isMemberAuth)).pipe(
      map(res => {
        
        this.postProgress = false;
        return res;
      }),
      catchError(err => {
        console.log(err.status);
        
        this.postProgress = false;
        return 'failed';
      })
    );
  }

  postExternalUrl(endpoint: string, body: any, reqOpts?: any) {
    return this.http.post(endpoint, body, this.getFormUrlEncode()).pipe(
      map(res => {
        
        return res;
      }));
  }

  postFormdata(endpoint: string, body: any, isMemberAuth?: any) {
    return this.http.post(this.url + '/' + endpoint, body, this.getHttpHeaders(isMemberAuth)).pipe(
      map(res => {
        
        return res;
      }));
  }

  
  private getHttpHeaders(isUserTokenRequired ? : boolean) {
    let headers = new HttpHeaders();
    if (window.localStorage['token'] && window.localStorage['token'] !== '') {
      if (isUserTokenRequired && window.localStorage['userToken'] != null && window.localStorage['userToken'] != "") {
        headers = new HttpHeaders().set('AuthToken', window.localStorage['token'])
        .set('WM_CONSUMER.ID', this.env.consumerId)
        .set('x-px-score','1').set("UserToken", window.localStorage['userToken']);
      } else {
        headers = new HttpHeaders().set('AuthToken', window.localStorage['token'])
        .set('WM_CONSUMER.ID', this.env.consumerId)
        .set('x-px-score','1');
      }
     
    } else {
       headers = new HttpHeaders().set('WM_CONSUMER.ID', '4ff6f540-b891-4cff-a267-cd13ff9ef44d')
      .set('x-px-score','1'); 
    }
    
    
    //headers.append("Connection", "timeout=5000");
    let obj = {headers}
    return obj;
  }

  private getFormUrlEncode() {
    let headers = new HttpHeaders();

    headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    let obj = {headers}
    return obj;
  }

}
